import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/pagination'
import { Pagination } from 'swiper/modules'
import ImageComponentHeightFixed from './ImageComponentHeightFixed'
import { GallerySlideProps } from '@/app/interface/components'
import React, { useState, useCallback, useEffect } from 'react'

const GallerySlide: React.FC<GallerySlideProps> = ({ imgs, width, height, isDesktop }) => {
  const [swiperInstance, setSwiperInstance] = useState<any>(null)

  const handleSlideChange = useCallback((swiper: any) => {
    adjustTranslate3d(swiper)
  }, [])

  const handleSwiper = (swiper: any) => {
    setSwiperInstance(swiper)
    handleSlideChange(swiper)
  }

  const adjustTranslate3d = (swiper: any) => {
    const offset = 187
    const distance = (swiper.activeIndex - 1) * offset

    if (isDesktop) swiper.setTranslate(-distance)
  }

  const handleImageClick = (index: number) => {
    if (!swiperInstance) return

    const currentIndex = swiperInstance.activeIndex
    const isLastSlide = currentIndex === imgs.length - 1

    if (index === currentIndex) {
      if (isLastSlide) {
        swiperInstance.slideTo(0)
      } else {
        swiperInstance.slideTo(currentIndex + 1)
      }
    } else {
      swiperInstance.slideTo(index)
    }
  }

  useEffect(() => {
    if (swiperInstance) {
      swiperInstance.slideTo(0)
    }
  }, [imgs, swiperInstance])

  const view = isDesktop ? 3 : 1

  return (
    <>
      <Swiper
        slidesPerView={view}
        spaceBetween={12}
        centeredSlides={true}
        pagination={{
          clickable: true,
        }}
        modules={[Pagination]}
        className="gallerySlide"
        onSlideChange={handleSlideChange}
        onSwiper={handleSwiper}
        allowTouchMove={!isDesktop}
      >
        {imgs.map((img: string, index: number) => (
          <SwiperSlide key={index} onClick={() => handleImageClick(index)}>
            <ImageComponentHeightFixed src={img} width={width} height={height} />
          </SwiperSlide>
        ))}
        <div style={{ height: 32 }}></div>
      </Swiper>
    </>
  )
}

export default React.memo(GallerySlide)